import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import setupInterceptors from '@/utils/axios/interceptors';
import { initMixpanel, registerSuperProperties } from '@/utils/analytics/mixpanel';
import { getInitialDevice } from '@/utils/analytics/device';
import CmoneyUI from '@cmoney/cmoney-ui';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faShoppingCart,
  faHouseChimney,
  faAngleDown,
  faBars,
  faUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';
import { faCopy, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import HighchartsVue from 'highcharts-vue';
import api from '@/mixins/api';
import admin from '@/mixins/admin';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import App from './App.vue';
import router from './router';
import store from './store';

import '@/assets/styles/app.scss';
import '@cmoney/cmoney-ui/dist/icons.css';

Vue.use(CmoneyUI);
Vue.component('v-select', vSelect);
Vue.use(HighchartsVue);
Vue.use(VueAxios, axios);
Vue.mixin(admin);
Vue.mixin(api);
Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(
  faShoppingCart,
  faHouseChimney,
  faAngleDown,
  faBars,
  faCopy,
  faSquareCheck,
  faUpRightFromSquare,
);

Vue.prototype.$deviceSize = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

Vue.config.productionTip = false;

setupInterceptors();

initMixpanel();
registerSuperProperties({ Device: getInitialDevice() });

// 在掛載前先初始化 OIDC manager，確保 router guard 執行時可直接取用
store.dispatch('auth/initialOidc');

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
